<template>
    <v-form @submit.prevent="saveCollaborator('formCollaborator')" data-vv-scope="formCollaborator" ref="formCollaborator" >
        <div class="flex-row mt-12">
            <div class="flex-col-12">
                <div class="flex-row">
                    <div class="flex-col-4">
                        <v-text-field label="CPF" v-model="membro.register" v-mask="CPFMask" :rules="[rules.required, rules.CPFValido]" tabindex="1" :readonly="membro.personId !== undefined" outlined></v-text-field>
                    </div>
                    <div class="flex-col-3">
                        <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="membro.dataNasc" label="Nascimento" readonly v-on="on" :rules="[rules.required]" tabindex="2" outlined></v-text-field>
                            </template>
                            <v-date-picker v-model="date" no-title @input="menu2 = false"></v-date-picker>
                        </v-menu>                    
                    </div>
                    <div class="flex-col-1">
                    </div>
                    <div class="flex-col-3">
                        <v-radio-group v-model="membro.sex" row class=" mt-0" :rules="[rules.required]" tabindex="3">
                            <v-radio label="Masculino" value="M"></v-radio>
                            <v-radio label="Feminino" value="F"></v-radio>
                        </v-radio-group>
                    </div>
                </div>

                <div class="flex-row">
                    <div class="flex-col-12">
                        <v-text-field label="Nome Completo" v-model="membro.name" :rules="[rules.required]" tabindex="4" :readonly="membro.personId !== undefined" outlined></v-text-field>
                    </div>

                    <div class="flex-col-4">
                        <v-text-field label="Telefone" v-model="membro.phoneContact" v-mask="telefoneMask" :rules="[rules.required]" tabindex="5" outlined @input="AtualizarMascaraTelefone()"></v-text-field>
                    </div>
                    <div class="flex-col-8">
                        <v-text-field label="E-mail comercial" type="email" v-model="membro.email" :rules="[rules.required, rules.mailAddress]" tabindex="6" :readonly="membro.personId !== undefined" outlined></v-text-field>
                    </div>
                </div>

                <!-- <div class="flex-row">
                    <div class="flex-col-2">
                        <v-text-field label="CEP" v-model="membro.zipCode" v-mask="CepMask" :rules="[rules.required]" tabindex="7" outlined @input="BuscarCep()"></v-text-field>
                    </div>
                    <div class="flex-col-5">
                        <v-text-field label="Logradouro" v-model="membro.address" :rules="[rules.required]" tabindex="8" outlined></v-text-field>
                    </div>
                    <div class="flex-col-2">
                        <v-text-field label="Nº" v-model="membro.number" :rules="[rules.required]" tabindex="9" outlined></v-text-field>
                    </div>
                    <div class="flex-col-3">
                        <v-text-field label="Complemento" v-model="membro.complement" tabindex="10" outlined></v-text-field>
                    </div>                                    
                </div> -->

                <!-- <div class="flex-row">                
                    <div class="flex-col-3">
                        <v-text-field label="Bairro" v-model="membro.location" :rules="[rules.required]" tabindex="11" outlined></v-text-field>
                    </div>                                
                    <div class="flex-col-2">
                        <v-text-field label="Cidade" v-model="membro.city" :rules="[rules.required]" tabindex="12" outlined></v-text-field>
                    </div>  
                    <div class="flex-col-2">
                        <v-autocomplete key="21" v-model="membro.uf" :items="getStatic.UF" label="UF" 
                        item-text="name" item-value="abbreviation" :rules="[rules.required]" tabindex="13" outlined>
                        </v-autocomplete>
                    </div>          
                </div> -->

                <div class="flex-row">
                    <div class="flex-col-12 text-right">
                        <!-- <v-btn color="info" type="submit" tabindex="14"><v-icon>check</v-icon>&nbsp; Salvar membro</v-btn>                 -->
                        <v-btn color="error" type="reset" text><v-icon>clear</v-icon>&nbsp; Limpar</v-btn>  
                        <v-btn color="info" type="submit" text tabindex="14"><v-icon>check</v-icon>&nbsp; Salvar</v-btn>  
                    </div>
                </div>

                <v-overlay :value="fullLoading">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
            </div>
        </div>
    </v-form>
</template>

<script>
import Vue from 'vue';
import Router from "@/router";
import { mask } from 'vue-the-mask';
import Helpers from "@/utilities/Helpers";
import { mapState, mapGetters } from "vuex";

    export default {
        mixins: [Helpers],   
        props: ["membro"],
        directives: {
        mask,
        },        
        data() {
            return {
                CPFMask: '###.###.###-##',
                telefoneMask:'(##)####-####',
                susepMask : '##.#######.#',
                CepMask: '#####-###',
                date: new Date().toISOString().substr(0, 10),
                menu2: false,
                fullLoading: false,
                rules: {
                    required: value => !!value || 'Obrigatório',
                    mailAddress: value => this.validEmail(value) || 'Utilize um e-mail válido.',
                    CPFValido: value => this.isCpf(value.replace('-', '').split('.').join('')) || 'CPF inválido',
                },              
            }
        },
        methods: {           
            FormatarNascimento()
            {
                console.log("FormatarNascimento");
                if(this.membro.personId !== undefined)
                {
                    this.membro.dataNasc = this.FormatarData(this.membro.birth);
                }
            },
            validEmail(email) {
                const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                console.log("validEmail");
                return re.test(email);
            },            
            AtualizarMascaraTelefone()
            {
                if(this.membro.phoneContact.length > 13)
                {
                    this.telefoneMask = '(##)#####-####';
                }
                else
                {
                    this.telefoneMask = '(##)####-####'; 
                }
            },
            BuscarCep()
            {
                if (this.membro.zipCode.replace('-', '').length == 8)
                {
                    this.fullLoading = true;                    

                    this.obterEndereco(this.membro.zipCode).then(response => {
                        const _endereco = response.data.data;
                        console.log(_endereco);

                        this.membro.address = _endereco.Logradouro;
                        this.membro.city = _endereco.Localidade;
                        this.membro.location = _endereco.Bairro;
                        this.membro.uf = _endereco.UF;
                        this.fullLoading = false;                    
                    }).catch(ex => {
                        this.fullLoading = false;
                    });
                }
            },
            saveCollaborator(scope)
            {
                if(this.$refs.formCollaborator.validate())
                {
                    this.fullLoading = true;
                    let person = 
                    {
                        id: this.membro.personId !== undefined ? this.membro.personId : 0,
                        code: this.membro.personCode !== undefined ? this.membro.personCode : null,
                        name: this.membro.name,
                        type: "F",
                        register: this.membro.register,
                        birth: this.membro.birth,
                        sex: this.membro.sex,
                        address: this.membro.address,
                        number: this.membro.number,
                        complement: this.membro.complement,
                        location:this.membro.location,
                        zipCode: this.membro.zipCode,
                        city: this.membro.city,
                        uf:this.membro.uf,
                        email: this.membro.email,
                        phoneContact: this.membro.phoneContact,
                        active: this.membro.personActive
                    };

                    this.$httpIdentityServerApi.post("person", person, {
                            headers: { "content-type": "application/json" }
                    }).then(response => {
                        let personId = response.data.data.id;
                        this.saveUser(personId);
                    }).catch(ex => {
                        console.log(ex);
                        this.showToast("error", "Erro", "Ocorreu um problema ao salvar.Tente novamente.");
                        this.loading = false;
                        this.fullLoading = false;
                    });                     

                }
            },
            saveUser(personId)
            {
                let user = {
                        id: this.membro.userId !== undefined ? this.membro.userId : 0,
                        code: this.membro.userCode !== undefined ? this.membro.userCode : null, 
                        userName: this.membro.email,
                        phoneNumber: this.membro.phoneContact,
                    };
                this.$httpIdentityServerApi.post("user", user, {
                        headers: { "content-type": "application/json" }
                }).then(response => {
                    let userId = response.data.data.id;
                    this.saveUserRole(personId, userId);             
                }).catch(ex => {
                    console.log(ex);
                    this.loading = false;
                    this.fullLoading = false;
                });                                 
            },
            saveUserRole(personId, userId)
            {
                let parentId = this.usuario.userId;
                let childRoleId = this.usuario.childRoleId;

                let userRole = {
                    id : this.membro.id !== undefined ? this.membro.id : 0,
                    roleId: parseInt(childRoleId),
                    userId: userId,
                    userParentId: parseInt(parentId),
                    personId: personId,
                    code: this.membro.code,
                    active: this.membro.active
                    //roleClaims: []
                };
                console.log("userRole");                  
                console.log(userRole);
                this.$httpIdentityServerApi.post("userRole", userRole, {
                        headers: { "content-type": "application/json" }
                }).then(response => {
                    this.loading = false;
                    this.fullLoading = false;
                    let mensagemToast = this.membro.id !== undefined ? "Colaborador atualizado com sucesso!" : "Colaborador cadastrado com sucesso!";
                    this.showToast("success", "Sucesso", mensagemToast);   
                    Router.push("/colaboradores-cadastro-unico");            
                }).catch(ex => {
                    console.log(ex);
                    this.loading = false;
                    this.fullLoading = false;
                });                 
            }
        },
        computed: {
            ...mapGetters("static", ["getStatic"]),
            ...mapGetters("usuarioModule", { usuario: "getUserInfo" }),
            computedDateFormatted () {
                return this.formatDate(this.date)
            },
        },
        watch: {
            date (val) {
                this.membro.dataNasc = this.FormatarData(this.date.split("-").join("/"));
                this.membro.birth = this.date;
            },
        },                
        mounted() { }        
    };
</script>
